export const downloadDataBlob = (blob, fileName, contentType = '') => {
    const url = window.URL.createObjectURL(new Blob([blob], { type: contentType }));
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
};
